import { useContext } from "react";

import { UserContext } from "components/UserContextProvider";

/** A hook to provide access to userContext stored in UserContext react context.
 * @returns An array containing the userContext state and the callback function to set it.
 * @see {@link UserContext}
 * @see UserContextProvider in components folder
 * @example const [userContext, onSetUserContext] = useUserContext();
 */
export default function useUserContext(): [IUserContext, onSetUserContext] {
    const [userContext, onSetUserContext] = useContext(UserContext);

    return [userContext, onSetUserContext];
}
